import React from "react";
import PropTypes from "prop-types";
import { HEADER_ACADEMY_LOGO_PRIMARY_SRC } from "../constants/headerBrandAssets";
import { getMessage } from "../data/locales";
import "./AuthScreenLayout.css";

const AuthScreenLayout = ({ children }) => (
  <div className="auth-screen">
    <div className="auth-screen-wrapper">
      <div className="auth-brand-header">
        <img
          src={HEADER_ACADEMY_LOGO_PRIMARY_SRC}
          alt={getMessage("auth.logoAlt")}
          className="auth-brand-logo ui-integrated-image"
          draggable="false"
          onContextMenu={(event) => event.preventDefault()}
        />
      </div>
      {children}
    </div>
  </div>
);

AuthScreenLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AuthScreenLayout;
